// utils/demandUtils.js
import jobDemandData from '../data/jobDemandData.json';
import { COUNTY_INDEX } from '../data/countyIndex';

// WDA names to the relevant counties
const WDA_County_Map = {
    "Olympic Consortium WDA: Kitsap county": ["Kitsap"],
    "Washington State": ["Washington State"],
    "South Central WDA: Skamania County": ["Skamania"],
    "Northwest WDA: Island, San Juan counties": ["Island", "San Juan"],
    "South Central WDA: Klickitat County": ["Klickitat"],
    "Seattle King WDA: King County": ["King"],
    "North Central WDA: Chelan Douglas counties": ["Chelan", "Douglas"],
    "Spokane WDA: Spokane County": ["Spokane"],
    "Snohomish WDA: Snohomish County": ["Snohomish"],
    "Northwest WDA: Whatcom county": ["Whatcom"],
    "Olympic Consortium WDA: Clallam, Jefferson counties": ["Clallam", "Jefferson"],
    "North Central WDA: Grant, Adams counties": ["Grant", "Adams"],
    "Northwest WDA: Skagit county": ["Skagit"],
    "Benton- Franklin WDA: Benton, Franklin counties": ["Benton", "Franklin"],
    "Eastern Washington WDA: Columbia, Walla Walla Counties": ["Columbia", "Walla Walla"],
    "Pacific Mountain WDA: Grays Harbor, Lewis, Mason, Pacific, Thurston counties": ["Grays Harbor", "Lewis", "Mason", "Pacific", "Thurston"],
    "Southwest WDA: Cowlitz, Wahkiakum counties": ["Cowlitz", "Wahkiakum"],
    "Tacoma-Pierce WDA: Pierce County": ["Pierce"],
    "South Central WDA: Yakima County": ["Yakima"],
    "North Central WDA: Okanogan County": ["Okanogan"],
    "Southwest WDA: Clark County": ["Clark"],
    "Eastern Washington WDA: Stevens, Ferry, Pend Oreille, Lincoln counties": ["Stevens", "Ferry", "Pend Oreille", "Lincoln"],
    "South Central WDA: Kittitas County": ["Kittitas"],
    "Eastern Washington WDA: Asotin, Whitman, Garfield Counties": ["Asotin", "Whitman", "Garfield"],
  };

export function getMaxDemandForWDA(onetSOC, workforce) {
  const selectedCounties = WDA_County_Map[workforce];
  if (!selectedCounties) return null;

  // Indices of selected counties in COUNTY_INDEX
  const countyIndices = selectedCounties
    .map((c) => COUNTY_INDEX.indexOf(c))
    .filter((i) => i !== -1);

  if (!countyIndices.length) return null;

  // Find the demand data for that SOC
  const demandEntry = jobDemandData.find((item) => item.onetSOC === onetSOC);
  if (!demandEntry) return null;

  // Pull out the numeric demand values for these counties
  const demandValues = countyIndices.map((idx) => demandEntry.demandByCounty[idx]);

  // Priority: 1 (In Demand) > 3 (Balanced) > 2 (No Demand) > null (N/A)
  if (demandValues.includes(1)) return 1;
  if (demandValues.includes(3)) return 3;
  if (demandValues.includes(2)) return 2;
  return null;
}